import { environment } from '@environments/environment';

export const APP_CONFIG = {
  module: 'U_SUPP_U',
  apiBaseUrl: environment.apiBaseUrl.replace(/\/+$/, ''),
  awsS3BaseUrl: environment.awsS3BaseUrl.replace(/\/+$/, ''),
};
